import { Controls, ReactFlow } from "@xyflow/react";
import "@xyflow/react/dist/style.css";
import { useEffect, useState } from "react";
import { filterWithNestedFilters, generateNodes } from "./utils";
import LoadableComp from "../../../commonComponents/LoadableComp/LoadableComp";
import { useSelector } from "react-redux";
import SortModal from "./SortModal";
import { getObjectChanges } from "../../../../utils";

const ADMIN_DEP_ID = "77580ca0-d85d-11ec-bd74-ed7d1f113010";

const FlowChart = ({
  setOpen,
  fetchedSrc,
  activeFilter,
  defaultFilters,
  mergedDepartments,
}) => {
  const { isDarkMode } = useSelector((state) => state.usersList);

  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [prevFilter, setPrevFilter] = useState(defaultFilters);
  const [graphVersion, setGraphVersion] = useState(0);
  const [nodes, setNodes] = useState([]);
  const [edges, setEdges] = useState([]);

  const setDelayedData = (cb) => {
    setNodes([]);
    setEdges([]);
    setTimeout(() => {
      cb();
    }, 1);
  };

  useEffect(() => {
    let array = [];
    if (!mergedDepartments) return;
    const idx = mergedDepartments.findIndex(
      (el) => el?.departmentId === ADMIN_DEP_ID
    );
    if (idx === -1) return;
    const adminDep = mergedDepartments[idx];

    array = filterWithNestedFilters(mergedDepartments, activeFilter).concat(
      adminDep
    );

    const { nodes, edges } = generateNodes(
      array,
      fetchedSrc,
      isDarkMode,
      setOpen,
      (department, role) => setModalOpen({ department, role })
    );
    const hasChanges = Object.keys(
      getObjectChanges(prevFilter, activeFilter) || {}
    ).length;
    if (hasChanges) {
      setGraphVersion((prev) => prev + 1);
      setPrevFilter(activeFilter);
      setDelayedData(() => {
        setNodes(nodes);
        setEdges(edges);
      });
      return;
    }
    setNodes(nodes);
    setEdges(edges);
  }, [mergedDepartments, fetchedSrc, isDarkMode, activeFilter]);

  useEffect(() => {
    let timeout;
    setLoading(true);

    timeout = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <LoadableComp loading={loading}>
      <div className="flowChartContainer">
        <ReactFlow key={graphVersion} nodes={nodes} edges={edges} fitView>
          <Controls
            showInteractive={false}
            showFitView={false}
            position="bottom-right"
          />
        </ReactFlow>
      </div>
      {!!modalOpen ? (
        <SortModal
          open={!!modalOpen}
          fetchedSrc={fetchedSrc}
          {...modalOpen}
          setOpen={setModalOpen}
        />
      ) : null}
    </LoadableComp>
  );
};

export default FlowChart;
